@if (!isLoading) {
  <div class="main-container" data-cy="forms-builder-preview-container">
    @if (!hideChrome) {
      <div class="action-container" data-cy="forms-builder-preview-action-container">
        <h4 class="preview-title" data-cy="forms-builder-preview-title">Form Preview</h4>
        <button mat-stroked-button
          class="layout-toggle-button"
          (click)="togglePreviewLayout()"
          data-cy="forms-builder-preview-layout-toggle">
          <mat-icon>{{ useDocumentFrame ? 'article' : 'view_stream' }}</mat-icon>
          {{ useDocumentFrame ? 'TDOS Print Preview' : 'TDOS Document View' }}
        </button>
        <button *ngIf="!embedded" mat-icon-button class="close-button" (click)="close()" data-cy="forms-builder-preview-close-button"><i class="material-icons">close</i></button>
        <mat-checkbox class="mobile-checkbox" [(ngModel)]="mobilePreview" (ngModelChange)="resetView()" data-cy="forms-builder-preview-mobile-checkbox">Mobile preview</mat-checkbox>
      </div>
    }
    <div class="form-preview-container" [class.legacy-layout]="!useDocumentFrame" data-cy="forms-builder-preview-form-container">
      <div class="preview-viewport" [class.legacy-layout]="!useDocumentFrame" #previewViewport data-cy="forms-builder-preview-viewport">
        <div class="document-frame"
          [class.legacy-mode]="!useDocumentFrame"
          [class.mobile-preview]="mobilePreview"
          [class.doc-letter]="useDocumentFrame && !mobilePreview && documentFormat === 'letter'"
          [class.doc-a4]="useDocumentFrame && !mobilePreview && documentFormat === 'a4'"
          data-cy="forms-builder-preview-document-frame">
          @if (!refreshingView && dataForm) {
            <div class="document-frame-content" data-cy="forms-builder-preview-form-view">
              <app-forms-form [cfgFormVersion]="cfgFormVersion"
                [dataForm]="dataForm"
                [isPreviewMode]="true"
                [saveEnabled]="false"
                [actionsEnabled]="false"
              data-cy="forms-builder-preview-form"></app-forms-form>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
